/**
 * Display names as Title Case, e.g. "mark spencer" → "Mark Spencer"
 */
export function toTitleCase(str) {
  if (str == null || str === "") return ""
  return String(str)
    .trim()
    .toLowerCase()
    .split(/\s+/)
    .filter(Boolean)
    .map((word) =>
      word
        .split("-")
        .map((part) =>
          part
            ? part.charAt(0).toUpperCase() + part.slice(1)
            : part
        )
        .join("-")
    )
    .join(" ")
}

/**
 * formatPersonName("mark", "spencer") → "Mark Spencer"
 * formatPersonName("mark spencer") → "Mark Spencer"
 */
export function formatPersonName(firstNameOrFull, lastName) {
  if (arguments.length >= 2) {
    return [firstNameOrFull, lastName]
      .filter((p) => p != null && String(p).trim() !== "")
      .map(toTitleCase)
      .join(" ")
      .trim()
  }
  return toTitleCase(firstNameOrFull)
}

export default formatPersonName
